/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateWorkingTimeBooking,
  CreateWorkingTimeBookingResponse,
  CreateWorkingTimeCorrectionRequest,
  DailyWorkingTimeBookings,
  GetMyWorkingTimeBookingPairsForDateParams,
  GetPagedWorkingTimeBookingsRequest,
  GetWorkingTimeBookingPairsForDateParams,
  GetWorkingTimeBookingPairsForDateResult,
  UpdateWorkingTimeBookingStatusRequest,
  WorkingTimeBookingDtoPagination,
  WorkingTimeBookingTypeDto,
  WorkingTimeRequest,
  WorkingTimeRequestResponse
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetWorkingTimeBookingsUrl = () => {




  return `/api/WorkingTimeBooking/GetWorkingTimeBookings`
}

export const getWorkingTimeBookings = async ( options?: Parameters<typeof customInstance>[1]): Promise<DailyWorkingTimeBookings[]> => {

  return customInstance<DailyWorkingTimeBookings[]>(getGetWorkingTimeBookingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkingTimeBookingsQueryKey = () => {
    return [
    `/api/WorkingTimeBooking/GetWorkingTimeBookings`
    ] as const;
    }


export const getGetWorkingTimeBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookings>>> = ({ signal }) => getWorkingTimeBookings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkingTimeBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookings>>>
export type GetWorkingTimeBookingsQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookings>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookings>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkingTimeBookingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookings>>> = ({ signal }) => getWorkingTimeBookings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWorkingTimeBookingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookings>>>
export type GetWorkingTimeBookingsSuspenseQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateWorkingTimeBookingUrl = () => {




  return `/api/WorkingTimeBooking/CreateWorkingTimeBooking`
}

export const createWorkingTimeBooking = async (createWorkingTimeBookingBody?: CreateWorkingTimeBooking, options?: Parameters<typeof customInstance>[1]): Promise<CreateWorkingTimeBookingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<CreateWorkingTimeBookingResponse>(getCreateWorkingTimeBookingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkingTimeBookingBody)
  }
);}





export const getCreateWorkingTimeBookingMutationKey = () => ['createWorkingTimeBooking'] as const;

export const getCreateWorkingTimeBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,CreateWorkingTimeBookingMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,CreateWorkingTimeBookingMutationVariables, TContext> => {

const mutationKey = getCreateWorkingTimeBookingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkingTimeBooking>>, CreateWorkingTimeBookingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorkingTimeBooking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkingTimeBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkingTimeBooking>>>
    export type CreateWorkingTimeBookingMutationBody = BodyType<CreateWorkingTimeBooking> | undefined
    export type CreateWorkingTimeBookingMutationError = ErrorType<unknown>
    export type CreateWorkingTimeBookingMutationVariables = {data?: BodyType<CreateWorkingTimeBooking>}

    export const useCreateWorkingTimeBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,CreateWorkingTimeBookingMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkingTimeBooking>>,
        TError,
        CreateWorkingTimeBookingMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorkingTimeBookingMutationOptions(options), queryClient);
    }
    export const getGetWorkingTimeBookingTypesUrl = () => {




  return `/api/WorkingTimeBooking/GetWorkingTimeBookingTypes`
}

export const getWorkingTimeBookingTypes = async ( options?: Parameters<typeof customInstance>[1]): Promise<WorkingTimeBookingTypeDto[]> => {

  return customInstance<WorkingTimeBookingTypeDto[]>(getGetWorkingTimeBookingTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkingTimeBookingTypesQueryKey = () => {
    return [
    `/api/WorkingTimeBooking/GetWorkingTimeBookingTypes`
    ] as const;
    }


export const getGetWorkingTimeBookingTypesQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>> = ({ signal }) => getWorkingTimeBookingTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkingTimeBookingTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>>
export type GetWorkingTimeBookingTypesQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkingTimeBookingTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>> = ({ signal }) => getWorkingTimeBookingTypes({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWorkingTimeBookingTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>>
export type GetWorkingTimeBookingTypesSuspenseQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeleteWorkingTimeBookingsByIdsUrl = () => {




  return `/api/WorkingTimeBooking/DeleteWorkingTimeBookingsByIds`
}

export const deleteWorkingTimeBookingsByIds = async (deleteWorkingTimeBookingsByIdsBody?: number[], options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeleteWorkingTimeBookingsByIdsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteWorkingTimeBookingsByIdsBody)
  }
);}





export const getDeleteWorkingTimeBookingsByIdsMutationKey = () => ['deleteWorkingTimeBookingsByIds'] as const;

export const getDeleteWorkingTimeBookingsByIdsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,DeleteWorkingTimeBookingsByIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,DeleteWorkingTimeBookingsByIdsMutationVariables, TContext> => {

const mutationKey = getDeleteWorkingTimeBookingsByIdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, DeleteWorkingTimeBookingsByIdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteWorkingTimeBookingsByIds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkingTimeBookingsByIdsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>>
    export type DeleteWorkingTimeBookingsByIdsMutationBody = BodyType<number[]> | undefined
    export type DeleteWorkingTimeBookingsByIdsMutationError = ErrorType<unknown>
    export type DeleteWorkingTimeBookingsByIdsMutationVariables = {data?: BodyType<number[]>}

    export const useDeleteWorkingTimeBookingsByIds = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,DeleteWorkingTimeBookingsByIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>,
        TError,
        DeleteWorkingTimeBookingsByIdsMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWorkingTimeBookingsByIdsMutationOptions(options), queryClient);
    }
    export const getGetPagedWorkingTimeBookingsUrl = () => {




  return `/api/WorkingTimeBooking/GetPagedWorkingTimeBookings`
}

export const getPagedWorkingTimeBookings = async (getPagedWorkingTimeBookingsRequest: GetPagedWorkingTimeBookingsRequest, options?: Parameters<typeof customInstance>[1]): Promise<WorkingTimeBookingDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<WorkingTimeBookingDtoPagination>(getGetPagedWorkingTimeBookingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getPagedWorkingTimeBookingsRequest)
  }
);}





export const getGetPagedWorkingTimeBookingsMutationKey = () => ['getPagedWorkingTimeBookings'] as const;

export const getGetPagedWorkingTimeBookingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,GetPagedWorkingTimeBookingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,GetPagedWorkingTimeBookingsMutationVariables, TContext> => {

const mutationKey = getGetPagedWorkingTimeBookingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, GetPagedWorkingTimeBookingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPagedWorkingTimeBookings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPagedWorkingTimeBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>>
    export type GetPagedWorkingTimeBookingsMutationBody = BodyType<GetPagedWorkingTimeBookingsRequest>
    export type GetPagedWorkingTimeBookingsMutationError = ErrorType<unknown>
    export type GetPagedWorkingTimeBookingsMutationVariables = {data: BodyType<GetPagedWorkingTimeBookingsRequest>}

    export const useGetPagedWorkingTimeBookings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,GetPagedWorkingTimeBookingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>,
        TError,
        GetPagedWorkingTimeBookingsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPagedWorkingTimeBookingsMutationOptions(options), queryClient);
    }
    export const getUpdateWorkingTimeBookingStatusUrl = () => {




  return `/api/WorkingTimeBooking/UpdateWorkingTimeBookingStatus`
}

export const updateWorkingTimeBookingStatus = async (updateWorkingTimeBookingStatusRequest: UpdateWorkingTimeBookingStatusRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateWorkingTimeBookingStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkingTimeBookingStatusRequest)
  }
);}





export const getUpdateWorkingTimeBookingStatusMutationKey = () => ['updateWorkingTimeBookingStatus'] as const;

export const getUpdateWorkingTimeBookingStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,UpdateWorkingTimeBookingStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,UpdateWorkingTimeBookingStatusMutationVariables, TContext> => {

const mutationKey = getUpdateWorkingTimeBookingStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, UpdateWorkingTimeBookingStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateWorkingTimeBookingStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkingTimeBookingStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>>
    export type UpdateWorkingTimeBookingStatusMutationBody = BodyType<UpdateWorkingTimeBookingStatusRequest>
    export type UpdateWorkingTimeBookingStatusMutationError = ErrorType<unknown>
    export type UpdateWorkingTimeBookingStatusMutationVariables = {data: BodyType<UpdateWorkingTimeBookingStatusRequest>}

    export const useUpdateWorkingTimeBookingStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,UpdateWorkingTimeBookingStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>,
        TError,
        UpdateWorkingTimeBookingStatusMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorkingTimeBookingStatusMutationOptions(options), queryClient);
    }
    export const getCreateWorkingTimeCorrectionUrl = () => {




  return `/api/WorkingTimeBooking/CreateWorkingTimeCorrection`
}

export const createWorkingTimeCorrection = async (createWorkingTimeCorrectionRequest: CreateWorkingTimeCorrectionRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCreateWorkingTimeCorrectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkingTimeCorrectionRequest)
  }
);}





export const getCreateWorkingTimeCorrectionMutationKey = () => ['createWorkingTimeCorrection'] as const;

export const getCreateWorkingTimeCorrectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,CreateWorkingTimeCorrectionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,CreateWorkingTimeCorrectionMutationVariables, TContext> => {

const mutationKey = getCreateWorkingTimeCorrectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, CreateWorkingTimeCorrectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorkingTimeCorrection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkingTimeCorrectionMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkingTimeCorrection>>>
    export type CreateWorkingTimeCorrectionMutationBody = BodyType<CreateWorkingTimeCorrectionRequest>
    export type CreateWorkingTimeCorrectionMutationError = ErrorType<unknown>
    export type CreateWorkingTimeCorrectionMutationVariables = {data: BodyType<CreateWorkingTimeCorrectionRequest>}

    export const useCreateWorkingTimeCorrection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,CreateWorkingTimeCorrectionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkingTimeCorrection>>,
        TError,
        CreateWorkingTimeCorrectionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorkingTimeCorrectionMutationOptions(options), queryClient);
    }
    export const getRequestWorkingTimeUrl = () => {




  return `/api/WorkingTimeBooking/RequestWorkingTime`
}

export const requestWorkingTime = async (workingTimeRequest: WorkingTimeRequest, options?: Parameters<typeof customInstance>[1]): Promise<WorkingTimeRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<WorkingTimeRequestResponse>(getRequestWorkingTimeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingTimeRequest)
  }
);}





export const getRequestWorkingTimeMutationKey = () => ['requestWorkingTime'] as const;

export const getRequestWorkingTimeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestWorkingTime>>, TError,RequestWorkingTimeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestWorkingTime>>, TError,RequestWorkingTimeMutationVariables, TContext> => {

const mutationKey = getRequestWorkingTimeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestWorkingTime>>, RequestWorkingTimeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestWorkingTime(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestWorkingTimeMutationResult = NonNullable<Awaited<ReturnType<typeof requestWorkingTime>>>
    export type RequestWorkingTimeMutationBody = BodyType<WorkingTimeRequest>
    export type RequestWorkingTimeMutationError = ErrorType<unknown>
    export type RequestWorkingTimeMutationVariables = {data: BodyType<WorkingTimeRequest>}

    export const useRequestWorkingTime = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestWorkingTime>>, TError,RequestWorkingTimeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestWorkingTime>>,
        TError,
        RequestWorkingTimeMutationVariables,
        TContext
      > => {
      return useMutation(getRequestWorkingTimeMutationOptions(options), queryClient);
    }
    export const getGetWorkingTimeBookingPairsForDateUrl = (params: GetWorkingTimeBookingPairsForDateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkingTimeBooking/GetWorkingTimeBookingPairsForDate?${stringifiedParams}` : `/api/WorkingTimeBooking/GetWorkingTimeBookingPairsForDate`
}

export const getWorkingTimeBookingPairsForDate = async (params: GetWorkingTimeBookingPairsForDateParams, options?: Parameters<typeof customInstance>[1]): Promise<GetWorkingTimeBookingPairsForDateResult> => {

  return customInstance<GetWorkingTimeBookingPairsForDateResult>(getGetWorkingTimeBookingPairsForDateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkingTimeBookingPairsForDateQueryKey = (params?: GetWorkingTimeBookingPairsForDateParams,) => {
    return [
    `/api/WorkingTimeBooking/GetWorkingTimeBookingPairsForDate`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkingTimeBookingPairsForDateQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingPairsForDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>> = ({ signal }) => getWorkingTimeBookingPairsForDate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkingTimeBookingPairsForDateQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>>
export type GetWorkingTimeBookingPairsForDateQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingPairsForDateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkingTimeBookingPairsForDateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingPairsForDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>> = ({ signal }) => getWorkingTimeBookingPairsForDate(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWorkingTimeBookingPairsForDateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>>
export type GetWorkingTimeBookingPairsForDateSuspenseQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkingTimeBookingPairsForDateSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyWorkingTimeBookingPairsForDateUrl = (params: GetMyWorkingTimeBookingPairsForDateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkingTimeBooking/GetMyWorkingTimeBookingPairsForDate?${stringifiedParams}` : `/api/WorkingTimeBooking/GetMyWorkingTimeBookingPairsForDate`
}

export const getMyWorkingTimeBookingPairsForDate = async (params: GetMyWorkingTimeBookingPairsForDateParams, options?: Parameters<typeof customInstance>[1]): Promise<GetWorkingTimeBookingPairsForDateResult> => {

  return customInstance<GetWorkingTimeBookingPairsForDateResult>(getGetMyWorkingTimeBookingPairsForDateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyWorkingTimeBookingPairsForDateQueryKey = (params?: GetMyWorkingTimeBookingPairsForDateParams,) => {
    return [
    `/api/WorkingTimeBooking/GetMyWorkingTimeBookingPairsForDate`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyWorkingTimeBookingPairsForDateQueryOptions = <TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyWorkingTimeBookingPairsForDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>> = ({ signal }) => getMyWorkingTimeBookingPairsForDate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyWorkingTimeBookingPairsForDateQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>>
export type GetMyWorkingTimeBookingPairsForDateQueryError = ErrorType<unknown>


export function useGetMyWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>,
          TError,
          Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>,
          TError,
          Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyWorkingTimeBookingPairsForDate<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyWorkingTimeBookingPairsForDateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyWorkingTimeBookingPairsForDateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyWorkingTimeBookingPairsForDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>> = ({ signal }) => getMyWorkingTimeBookingPairsForDate(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyWorkingTimeBookingPairsForDateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>>
export type GetMyWorkingTimeBookingPairsForDateSuspenseQueryError = ErrorType<unknown>


export function useGetMyWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyWorkingTimeBookingPairsForDateSuspense<TData = Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError = ErrorType<unknown>>(
 params: GetMyWorkingTimeBookingPairsForDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyWorkingTimeBookingPairsForDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyWorkingTimeBookingPairsForDateSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






